module.exports = __webpack_public_path__ + "img/Jump Casting1.3954e58c.jpg";